var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTheatreRightImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 126,
    viewBox: "0 0 155 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.5302 117.299C98.4102 117.299 107.23 108.479 107.23 97.5994C107.23 86.7194 98.4102 77.8994 87.5302 77.8994C76.6501 77.8994 67.8301 86.7194 67.8301 97.5994C67.8301 108.479 76.6501 117.299 87.5302 117.299Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9003 115.91C100.78 115.91 109.6 107.09 109.6 96.2098C109.6 85.3298 100.78 76.5098 89.9003 76.5098C79.0203 76.5098 70.2002 85.3298 70.2002 96.2098C70.2002 107.09 79.0203 115.91 89.9003 115.91Z",
    fill: "#FFD8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5498 95.6699C83.6398 102.36 90.7398 106.08 97.4298 103.99",
    stroke: "#FFA940",
    strokeWidth: 1.2236,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7505 87.9795C88.4298 87.9795 88.9805 87.4288 88.9805 86.7495C88.9805 86.0702 88.4298 85.5195 87.7505 85.5195C87.0712 85.5195 86.5205 86.0702 86.5205 86.7495C86.5205 87.4288 87.0712 87.9795 87.7505 87.9795Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.791 94.6895C102.47 94.6895 103.021 94.1388 103.021 93.4595C103.021 92.7802 102.47 92.2295 101.791 92.2295C101.111 92.2295 100.561 92.7802 100.561 93.4595C100.561 94.1388 101.111 94.6895 101.791 94.6895Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4501 18.9504C80.1501 9.51035 73.0701 1.30035 63.6201 0.610352",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.529 59.3114L135.994 64.8164L141.499 74.3511L151.034 68.8461L145.529 59.3114Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8539 7.86062L92.7236 5.85059L90.7136 10.9809L95.8439 12.9909L97.8539 7.86062Z",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.03 8L32.79 19.95L43.76 15.04L34.03 8Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.41 101.18L53.41 91.4199L48.46 102.37L60.41 101.18Z",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2501 97.9697C25.7701 97.9697 25.2902 97.7897 24.9202 97.4197L21.4801 93.9797C20.7501 93.2497 20.7501 92.0597 21.4801 91.3297C22.2101 90.5997 23.4001 90.5997 24.1301 91.3297L27.5701 94.7697C28.3001 95.4997 28.3001 96.6897 27.5701 97.4197C27.2101 97.7897 26.7301 97.9697 26.2501 97.9697Z",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.7 37.1303C132.28 37.1303 131.861 36.9703 131.541 36.6503C130.901 36.0103 130.901 34.9603 131.541 34.3203L134.561 31.3003C135.201 30.6603 136.241 30.6603 136.891 31.3003C137.531 31.9403 137.531 32.9903 136.891 33.6303L133.871 36.6503C133.541 36.9703 133.12 37.1303 132.7 37.1303Z",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.9 23.4803C153.612 23.4803 155 22.0924 155 20.3803C155 18.6682 153.612 17.2803 151.9 17.2803C150.188 17.2803 148.8 18.6682 148.8 20.3803C148.8 22.0924 150.188 23.4803 151.9 23.4803Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.93 105.02C134.062 105.02 134.98 104.102 134.98 102.97C134.98 101.838 134.062 100.92 132.93 100.92C131.798 100.92 130.88 101.838 130.88 102.97C130.88 104.102 131.798 105.02 132.93 105.02Z",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.63 49.7002L77.2998 65.9802",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9899 124.67L9.37988 111.3",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4896 30.6797C63.9296 47.5097 54.7196 65.5297 37.8896 70.9797",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0599 59.3005C21.5931 59.3005 27.6998 53.1937 27.6998 45.6605C27.6998 38.1273 21.5931 32.0205 14.0599 32.0205C6.52677 32.0205 0.419922 38.1273 0.419922 45.6605C0.419922 53.1937 6.52677 59.3005 14.0599 59.3005Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3695 57.4402C22.9027 57.4402 29.0095 51.3333 29.0095 43.8002C29.0095 36.267 22.9027 30.1602 15.3695 30.1602C7.83634 30.1602 1.72949 36.267 1.72949 43.8002C1.72949 51.3333 7.83634 57.4402 15.3695 57.4402Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7902 44.6198C22.3902 49.0198 11.7301 49.1198 11.7301 49.1198C11.7301 49.1198 8.33018 39.2998 12.2702 37.1898C17.0302 34.6398 17.5302 40.8998 17.5302 40.8998C17.5302 40.8998 23.2502 39.5198 22.7902 44.6198Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.86026 38.6104C3.84026 42.8904 4.86029 48.7904 9.14029 51.8204",
    stroke: "white",
    strokeWidth: 1.2236,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1202 33.7598L76.2803 56.5998",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.7 120.86C137.17 122.06 145.81 115.37 147.01 105.89",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheatreRightImage);
export default __webpack_public_path__ + "static/media/theatreRightImage.ec28a8edf13c5c3f066f369ba5e1c976.svg";
export { ForwardRef as ReactComponent };